"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColorNames = exports.getFieldOptionColor = void 0;
const color_1 = __importDefault(require("color"));
const _colors_1 = require("./_colors");
const COLOR_INDEX_NAME = [
    'deepPurple',
    'indigo',
    'blue',
    'teal',
    'green',
    'yellow',
    'orange',
    'tangerine',
    'pink',
    'red',
];
// five level alpha transparency
const COLOR_LEVEL_ALPHA = [0.2, 0.4, 0.6, 0.8, 1];
const rgba2hex = (foregroundColor, backgroundColor = '#FFFFFF') => {
    const getAdjustedChannel = (fValue, bValue, opacity) => opacity * fValue + (1 - opacity) * bValue;
    const fc = (0, color_1.default)(foregroundColor);
    const bc = (0, color_1.default)(backgroundColor);
    const opacity = fc.alpha();
    const adjustedColor = (0, color_1.default)([
        getAdjustedChannel(fc.red(), bc.red(), opacity),
        getAdjustedChannel(fc.green(), bc.green(), opacity),
        getAdjustedChannel(fc.blue(), bc.blue(), opacity),
    ]);
    return adjustedColor.hex();
};
const getColorValue = (color, alpha) => {
    return rgba2hex((0, color_1.default)(color).alpha(alpha).string());
};
/**
 * get single or multiple color object, transformed by color number
 *
 * 0 => deepPurple_1
 * 10 => deepPurple_2
 * 11 => indigo_2
 * @param index option.color
 */
function getFieldOptionColor(index) {
    const hue = COLOR_INDEX_NAME[index % COLOR_INDEX_NAME.length];
    const level = Math.floor(index / COLOR_INDEX_NAME.length);
    const baseColorValue = _colors_1.COLOR_MAP[hue];
    const value = getColorValue(baseColorValue, COLOR_LEVEL_ALPHA[level]);
    return {
        name: `${hue}_${level}`,
        value,
    };
}
exports.getFieldOptionColor = getFieldOptionColor;
/**
 * get all color name array, index is color number
 */
const getColorNames = () => {
    const colorNames = [];
    const colorNumMax = COLOR_INDEX_NAME.length * COLOR_LEVEL_ALPHA.length;
    for (let i = 0; i < colorNumMax; i++) {
        const hue = COLOR_INDEX_NAME[i % COLOR_INDEX_NAME.length];
        const level = Math.floor(i / COLOR_INDEX_NAME.length);
        colorNames.push(`${hue}_${level}`);
    }
    return colorNames;
};
exports.getColorNames = getColorNames;
//# sourceMappingURL=color.js.map